import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";

const AboutMe = () => {
  const acheivements = [
    { name: "5x Best Impromptu Speaker - Toastmasters International" },
    { name: "1st Runner-Up, National Hindi Debate Championship" },
    { name: "1st Runner-Up, National Hindi Poetry Championship" },
    { name: "Champion, National Hindi Monologue Competition" },
    { name: "13th, National Public Speaking Championship 2019" },
    { name: "1x Best Delegate & Speaker - North Vistarian Model Cabinet" },
    { name: "2x Best Delegate - Singapore Model United Nations" },
    { name: "1x Best Delegate - Singapore Model Cabinet" },
    {
      name: "Quarterfinalist, Singapore Secondary School Debating Championship",
    },
  ];
  return (
    <>
      <div className="dark:bg-neutral-950 relative w-full flex items-center justify-center mt-44 mb-10">
        <section className="items-center">
          <motion.h3
            initial={{ y: 48, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ ease: "easeInOut", duration: 0.75 }}
            className="mb-5 text-2xl font-black uppercase text-zinc-50 text-center"
          >
            About Me
          </motion.h3>{" "}
        </section>
      </div>
      <div className="dark:bg-neutral-950 relative w-full flex items-center justify-center">
        <div className="pb-48 flex items-center justify-center text-white dark:text-white">
          <div className="max-w-5xl w-full p-6 grid grid-cols-1 md:grid-cols-2 gap-10">
            {/* Left Section */}
            <div>
              <h1 className="text-5xl font-bold text-white mb-4">
                Writer. Photographer.{" "}
                <span className="text-green">Journalist.</span>
              </h1>

              <p className="text-white mt-6 mb-5">
                The realms of media, technology, and vocal arts have always
                captivated my interest. I aspire to be a broadcast Journalist in
                the future. Here are my acheivements!
              </p>
              {acheivements.map((achievement, index) => (
                <p key={index}>- {achievement.name}</p>
              ))}
              <div className="mt-6 flex items-center gap-4">
                <button className="flex items-center px-4 py-2 rounded-xl text-white bg-green">
                  <Link href="/files/portfolio.pdf" target="_blank">
                    View resume
                  </Link>
                </button>
              </div>
            </div>
            {/* Right Section */}
            <div>
              <div className="mb-6">
                <Image
                  src={"/pictures/adi2.jpg"}
                  alt={"Aditya Image"}
                  width={450}
                  height={450}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutMe;
